import { App, Button, Form, Input, Row, Col } from 'antd';

import { TokenUpdate } from '../api/go';

interface EditForm {
  token: string;
}

async function updateToken(token: string) {
  await TokenUpdate(token);
}

// 展示信用分的历史，当前值，和修改按钮

export default function SystemToken() {
  const { message } = App.useApp();
  return (
    <div>
      <Row>
        <Col span={8}>
          <Form
            name="update_token"
            layout="horizontal"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ maxWidth: 600 }}
            onFinish={(values: EditForm) => {
              updateToken(values.token).then(() => {
                message.success('更新成功');
              });
            }}
            autoComplete="off"
          >
            <Form.Item<EditForm> label="token" name="token" required>
              <Input />
            </Form.Item>

            <Form.Item label={null}>
              <Button type="primary" htmlType="submit">
                修改
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
}
